/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptSaveRequest {
    getFixupPrototypeFunction() { return PromptSaveRequest.fixupPrototype; }

    static newInstance(model: Partial<PromptSaveRequest>): PromptSaveRequest {
        let obj = Object.assign(new PromptSaveRequest(), model);
        PromptSaveRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptSaveRequest>): PromptSaveRequest {
        if (!model) return null;
        return PromptSaveRequest.newInstance(<PromptSaveRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptSaveRequest) {
        if (!obj) return;

        models.PromptSaveRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptSaveRequest): boolean {
        Object.setPrototypeOf(obj, PromptSaveRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Input given to the agent
     */
    prompt: string;

    /**
     * ID of the agent
     */
    agent_id: string;

    /**
     * List of tag key/value pairs
     */
    tags: Array<models.KeyValuePair>;

}
